import { render, staticRenderFns } from "./StopeTarpHistoryDialog.vue?vue&type=template&id=8a799226&scoped=true&"
import script from "./StopeTarpHistoryDialog.vue?vue&type=script&lang=ts&"
export * from "./StopeTarpHistoryDialog.vue?vue&type=script&lang=ts&"
import style0 from "./StopeTarpHistoryDialog.vue?vue&type=style&index=0&id=8a799226&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a799226",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSparkline } from 'vuetify/lib/components/VSparkline';
installComponents(component, {VBtn,VIcon,VSimpleTable,VSpacer,VSparkline})
